import { ActivityCategory, AvatarConfig } from './user';

export const REACTION_EMOJIS = ['🔥', '❤️', '💀', '💯', '👀'] as const;
export type ReactionEmoji = typeof REACTION_EMOJIS[number];

export const REACTION_KEYS: Record<ReactionEmoji, string> = {
  '🔥': 'fire',
  '❤️': 'heart',
  '💀': 'skull',
  '💯': 'hundred',
  '👀': 'eyes',
};

export const PIN_LIFETIME_MS = 24 * 60 * 60 * 1000; // 24 hours

export interface Pin {
  id: string;
  creatorId: string;
  creatorNick: string;
  creatorAvatar?: AvatarConfig;
  lat: number;
  lng: number;
  text: string;
  category: ActivityCategory;
  imageData?: string;
  videoData?: string; // base64 video (max ~5MB)
  videoThumbnail?: string; // thumbnail for video preview
  mediaType?: 'image' | 'video';
  markerImage?: string;
  locationName?: string; // Reverse-geocoded place name
  createdAt: number;
  expiresAt: number;
  // Reaction counts
  reactions_fire: number;
  reactions_heart: number;
  reactions_skull: number;
  reactions_hundred: number;
  reactions_eyes: number;
  commentCount: number;
}

export interface PinComment {
  id: string;
  authorId: string;
  authorNick: string;
  authorAvatar?: AvatarConfig;
  text: string;
  imageData?: string;
  createdAt: number;
}

export function getReactionCount(pin: Pin, emoji: ReactionEmoji): number {
  const key = REACTION_KEYS[emoji];
  return (pin as any)[`reactions_${key}`] || 0;
}

export function getTotalReactions(pin: Pin): number {
  return REACTION_EMOJIS.reduce((sum, e) => sum + getReactionCount(pin, e), 0);
}

export function isPinExpired(pin: Pin): boolean {
  return Date.now() > pin.expiresAt;
}

export function timeUntilExpiry(pin: Pin): string {
  const remaining = pin.expiresAt - Date.now();
  if (remaining <= 0) return 'Expired';
  const hours = Math.floor(remaining / 3600000);
  const mins = Math.floor((remaining % 3600000) / 60000);
  if (hours > 0) return `${hours}h ${mins}m left`;
  return `${mins}m left`;
}
